export const historicalFulfillmentTime = {
    name: "HistoricalFulfillmentTime",
    variants: [
        ["Control", 1],
        ["Test", 1],
    ],
    controlVariant: "Control",
    apply: ({ assignVariant, clearVariant, isParticipatingInOtherTests }) => {
        if (Skubacz.configuration.environment === "systemtest") {
            return;
        }
        const isInOtherTest = isParticipatingInOtherTests();
        if (!isInOtherTest) {
            assignVariant();
        }
        else {
            clearVariant();
        }
    },
};
